import React, { Component } from 'react';
import { Doughnut, Line } from 'react-chartjs-2';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'antd/dist/antd.css';

class LineDoughnut extends Component {
    constructor(props) {
        super(props);

        this.state = {
            followlist: [],
        }
    }

    componentDidMount() {
        this.setState({
            followlist: this.props.followlist
        })
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.followlist !== nextProps.followlist) {
            this.setState({
                followlist: nextProps.followlist,
            })
        }
    }

    render() {
        const doughnut = {
            labels: [
                'Block',
                'Friend',
                'None',
                'Unverified'
            ],
            datasets: [{
                data: this.state.followlist,
                backgroundColor: [
                    '#FFA469',
                    '#8632FF',
                    '#ACAFB2',
                    '#000000'
                ],
                hoverBackgroundColor: [
                    '#FFA469',
                    '#8632FF',
                    '#ACAFB2',
                    '#000000'
                ]
            }]
        };
        const option = {
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        var dataset = data.datasets[tooltipItem.datasetIndex];
                        var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                        var total = meta.total;
                        var currentValue = dataset.data[tooltipItem.index];
                        var percentage = parseFloat((currentValue / total * 100).toFixed(1));
                        return currentValue + ' (' + percentage + '%)';
                    },
                    title: function (tooltipItem, data) {
                        return data.labels[tooltipItem[0].index];
                    }
                }
            },
            plugins: {
                datalabels: {
                    formatter: (value, ctx) => {
                        let sum = 0;
                        let dataArr = ctx.chart.data.datasets[0].data;
                        dataArr.map(data => {
                            sum += data;
                        });
                        let percentage = (value * 100 / sum).toFixed(2);
                        return percentage + '%';
                    },
                    color: '#fff',
                }
            },
            maintainAspectRatio: false,
            responsive: true,
            cutoutPercentage: 70,
            legend: {
                display: true,
                position: 'right'
            }
        };

        return (
            <div className="chart-wrapper">
                <Doughnut
                    height={130}
                    data={doughnut}
                    options={option}
                />
            </div>
        );
    }
}

export default LineDoughnut;


// WEBPACK FOOTER //
// ./src/views/Dashboard/LineDoughnut.js